// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"7904d209","693":"7904d209"}[chunkId] + ".chunk.css";
};